import { render, staticRenderFns } from "./under-maintenance.vue?vue&type=template&id=3af81ba6"
import script from "./under-maintenance.vue?vue&type=script&lang=js"
export * from "./under-maintenance.vue?vue&type=script&lang=js"
import style0 from "./under-maintenance.vue?vue&type=style&index=0&id=3af81ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports